import { all, call, put, takeLatest } from "redux-saga/effects";

import { ApiManager } from "services/api";
import { ApplicationSerializer } from "services/api/applications";
import { RequestAction } from "store/entities/actions";

import { ApplicationsActionNames, ApplicationsActions } from "./actions";

const { applicationsApi } = ApiManager;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchInstalledApps() {
  const { result, error } = yield call(applicationsApi.fetchInstalledApps);

  if (error) {
    yield put(ApplicationsActions.fetchInstalledAppsFailure({ error }));
  } else {
    const applications = Array.isArray(result) ? result : [];
    yield put(ApplicationsActions.fetchInstalledAppsSuccess(ApplicationSerializer.deserializeList(applications)));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchPrivateApps() {
  const { result, error } = yield call(applicationsApi.fetchPrivateApps);

  if (error) {
    yield put(ApplicationsActions.fetchPrivateAppsFailure({ error }));
  } else {
    const applications = Array.isArray(result) ? result : [];
    yield put(ApplicationsActions.fetchPrivateAppsSuccess(ApplicationSerializer.deserializeList(applications)));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchInReviewApps() {
  const { result, error } = yield call(applicationsApi.fetchInReviewApps);

  if (error) {
    yield put(ApplicationsActions.fetchInReviewAppsFailure({ error }));
  } else {
    const applications = Array.isArray(result) ? result : [];
    yield put(ApplicationsActions.fetchInReviewAppsSuccess(ApplicationSerializer.deserializeList(applications)));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* applicationsSagas() {
  yield all([
    takeLatest(ApplicationsActionNames.INSTALLED_APPS[RequestAction.REQUEST], fetchInstalledApps),
    takeLatest(ApplicationsActionNames.PRIVATE_APPS[RequestAction.REQUEST], fetchPrivateApps),
    takeLatest(ApplicationsActionNames.IN_REVIEW_APPS[RequestAction.REQUEST], fetchInReviewApps),
  ]);
}
